import TrophyIcon from "@redotech/redo-icons/trophy-01.svg";
import { JSXElementConstructor, memo } from "react";
import {
  FeaturedIconColor,
  RedoFeaturedIcon,
} from "../../../arbiter-components/featured-icon/redo-featured-icon";
import { Flex } from "../../../flex";
import { TextAndSupportingText } from "../../../text-and-supporting-text";

export const PopupHeader = memo(function PopupHeader({
  title,
  description,
  Icon = TrophyIcon,
  iconColor = "gray",
}: {
  title: string;
  description?: string;
  Icon?: JSXElementConstructor<any>;
  iconColor?: FeaturedIconColor;
}) {
  return (
    <Flex align="center" dir="row" gap="lg">
      <RedoFeaturedIcon
        color={iconColor}
        Icon={Icon}
        shape="square"
        size="md"
        type="default"
      />
      <TextAndSupportingText
        align="flex-start"
        mainTextSize="sm"
        supportingText={description ?? ""}
        supportingTextSize="xs"
        text={title}
      />
    </Flex>
  );
});
